'use client';

import Image from 'next/image';
import Bandmix from '../../bandmix-screenshot.png';
import { useState } from 'react';

interface FAQToggleProps {
  question: string;
  answer: string | React.ReactNode;
}

export default function FAQToggle({ question, answer }: FAQToggleProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mb-8 bg-white p-6">
      <button
        className="w-full py-6 text-left flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-xl md:text-2xl font-[900] text-gray-900">
          {question}
        </h3>
        <span className="ml-6 flex-shrink-0 text-gray-900">
          {isOpen ? (
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 15l7-7 7 7"
              />
            </svg>
          ) : (
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          )}
        </span>
      </button>
      <div className={`pb-6 ${isOpen ? 'block' : 'hidden'}`}>
        <div className="text-lg md:text-xl leading-8 text-gray-900">
          {typeof answer === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: answer }} />
          ) : (
            answer
          )}
        </div>
      </div>
    </div>
  );
}
